module.exports = __webpack_public_path__ + "img/data-effects.31d3c818.png";